import { render, staticRenderFns } from "./RegisterDetail.vue?vue&type=template&id=6d61d866&scoped=true&"
import script from "./RegisterDetail.vue?vue&type=script&lang=js&"
export * from "./RegisterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61d866",
  null
  
)

export default component.exports